import * as React from 'react';
import { Radio as $Radio } from 'antd';
import { FieldProps } from 'formik';
import { Field } from 'formik-antd';
import { FormikFieldProps } from 'formik-antd/lib/FieldProps';
import { RadioGroupProps as $RadioGroupProps } from 'antd/lib/radio/interface';

export type RadioGroupProps = FormikFieldProps & $RadioGroupProps;

export const Radio = ({
  name,
  validate,
  fast,
  onChange,
  ...restProps
}: RadioGroupProps) => (
  <Field name={name} validate={validate} fast={fast}>
    {({
      field: { value },
      form: { setFieldValue, setFieldTouched },
    }: FieldProps) => (
      // eslint-disable-next-line react/jsx-pascal-case
      <$Radio
        value={value}
        onChange={(event) => {
          setFieldValue(name, event.target.value);
          onChange && onChange(event);

          setTimeout(() => {
            setFieldTouched(name, true, false);
          }, 0);
        }}
        {...restProps}
      />
    )}
  </Field>
);

export default Radio;

Radio.Group = ({
  name,
  validate,
  fast,
  onChange,
  ...restProps
}: RadioGroupProps) => (
  <Field name={name} validate={validate} fast={fast}>
    {({
      field: { value },
      form: { setFieldValue, setFieldTouched },
    }: FieldProps) => (
      // eslint-disable-next-line react/jsx-pascal-case
      <$Radio.Group
        value={value}
        onChange={(event) => {
          setFieldValue(name, event.target.value);
          onChange && onChange(event);

          setTimeout(() => {
            setFieldTouched(name, true, false);
          }, 0);
        }}
        {...restProps}
      />
    )}
  </Field>
);

Radio.Button = $Radio.Button;
